<template>
  <transition name="animation-fade-up">
    <StickyAudioplayer class="player" v-if="!isAdaptive && isPanelOpen"/>
  </transition>
</template>

<script setup>
  import { useAudioplayerAdaptiveMode } from '@/Groups/Audioplayer/private/composables/adaptiveModeControl';
  import { useAudioPlayerState } from '@/Groups/Audioplayer/private/composables/computedValues';
  //-------------------------
  import StickyAudioplayer from '@/Groups/Audioplayer/private/core/StickyAudioplayer/StickyAudioplayer.vue';
  //-------------------------
  const { isPanelOpen } = useAudioPlayerState();
  //-------------------------
  const { isAdaptive } = useAudioplayerAdaptiveMode();
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>